<template>
  <svg width="24" height="24" aria-hidden="true" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="Icon Icon--angle-down ">
    <path d="M12 15L11.6464 15.3536L12 15.7071L12.3536 15.3536L12 15ZM5.64645 9.35355L11.6464 15.3536L12.3536 14.6464L6.35355 8.64645L5.64645 9.35355ZM12.3536 15.3536L18.3536 9.35355L17.6464 8.64645L11.6464 14.6464L12.3536 15.3536Z" fill="currentColor"></path>
  </svg>
</template>
<script setup lang="ts"></script>